import { render, staticRenderFns } from "./AddFeature.vue?vue&type=template&id=6205b4b4&scoped=true"
import script from "./AddFeature.vue?vue&type=script&lang=js"
export * from "./AddFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6205b4b4",
  null
  
)

export default component.exports